import * as React from "react";
import { QueryRoute } from "bernie-core";
import { ESSAdapter, UitkTypeahead, TypeaheadToolbarVersion } from "uitk-react-typeahead";
import { Layer } from "bernie-view";
import { DestinationFieldProps } from "../typings";
import { WizardDialogTrigger } from "./WizardDialogTrigger";
import { hotelConfig } from "src/stores/wizard/config";

const DestinationTypeaheadDialog = (children: JSX.Element) => {
  return (
    <QueryRoute query={{ pwaDialog: "destination" }}>
      <Layer id="typeahead">{children}</Layer>
    </QueryRoute>
  );
};

export const DestinationField = (props: DestinationFieldProps) => {
  const typeaheadDialogClose = () => {
    props.closeDialog(WizardDialogTrigger.TYPEAHEADCLOSE);
  };

  return (
    <UitkTypeahead
      adapter={
        new ESSAdapter({
          client: "HotelsLandingPage",
          dest: true,
          essLogger: props.essAnalyticsLogger,
          features:
            "contextual_ta|postal_code|uta_client|google|multiregion_parent|ta_hierarchy|consistent_display",
          guid: props.guid,
          inputId: props.formFieldModel.formFieldStid,
          lob: "HOTELS",
          locale: props.locale,
          maxResults: hotelConfig.location.destination.essAdapterConfig.maxResults,
          regionType: 2047,
          siteId: parseInt(props.siteId, 10),
          personalize: false
        })
      }
      onClick={props.openDialog}
      onDismiss={typeaheadDialogClose}
      onUpdate={props.updateDestinationField}
      renderDialog={DestinationTypeaheadDialog}
      hasClearButton={false}
      allowExactMatch={true}
      icon="place"
      name={props.formFieldModel.formFieldName}
      stid={props.formFieldModel.formFieldStid}
      label={props.l10n.formatText(props.formFieldModel.formFieldLabel)}
      toolbarVersion={TypeaheadToolbarVersion.V1}
      invalid={props.invalid}
      value={props.destination || ""}
    />
  );
};
